import { makeStyles } from '@eagleview/ev-comp-library';

export default makeStyles((theme) => ({
  contactInfocontainer: {
    display: 'flex',
    flex: '1 1 auto',
    flexWrap: 'nowrap',
    minwidth: '0',
    gap: '16px',
    backgroundColor: '#F0F2F7',
    flexDirection: 'column-reverse',
    '@media (min-width: 1024px)': {
      flexDirection: 'row',
      padding: '16px 24px',
    },
  },
  topContainer: {
    display: 'flex',
    flex: '1 1 auto',
    gap: '16px',
    flexWrap: 'nowrap',
    '@media (min-width: 1200px)': {
      flexDirection: 'row',
      gap: 16,
    },
  },
  paper: {
    display: 'flex',
    margin: '0px',
    padding: '16px',
    flex: 1,
    borderRadius: '0px',
    boxShadow: '0px',
    flexDirection: 'column',
    '@media (min-width: 640px)': {
      boxShadow: '0px 1px 3px 0px rgba(0, 0, 0, 0.2),0px 2px 2px 0px rgba(0, 0, 0, 0.12), 0px 0px 2px 0px rgba(0, 0, 0, 0.14)',
      flexDirection: 'row',
      borderRadius: '4px',
    },
  },
  logopaper: {
    display: 'flex',
    flex: '1 auto',
    minWidth: '348px',
    height: 'fit-content',
    padding: '24px',
    background: '#F0F2F7',
    flexDirection: 'row',
    marginBottom: '-16px',
    borderRadius: '0px',
    boxShadow: '0px 1px 3px 0px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.12), 0px 0px 2px 0px rgba(0, 0, 0, 0.14)',
    '@media (min-width: 1024px)': {
      flexDirection: 'column',
      background: '#FFFFFF',
      justifyContent: 'center',
      borderRadius: '4px',
    },
  },
  logoDetail: {
    flex: '1 1 auto',
    padding: '24px',
    background: '#FFFFFF',
    border: `1px solid ${theme.evPalette.charcoal[400]}`,
    '@media (min-width: 1024px)': {
      padding: '0px',
      border: '0px',
    },
  },
  contactDetails: {
    display: 'flex',
    margin: '0px',
    padding: '16px',
    gap: '16px',
    flex: 1,
    flexDirection: 'column',
  },
  alert: {
    borderBottom: `1px solid ${theme.evPalette.rose[900]}`,
    paddingTop: '8px',
    paddingLeft: '16px',
    paddingRight: '16px',
    backgroundColor: theme.evPalette.rose[100],
    borderColor: theme.evPalette.rose[900],
    borderRadius: '0px',
    '& ul': {
      paddingLeft: '24px',
      marginTop: '0px',
      color: theme.evPalette.huckleberry[800],
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'left',
      marginBottom: '0px',
    },
    '& li': {
      color: theme.evPalette.huckleberry[800],
      cursor: 'pointer',
      width: 'fit-content',
    },
    '& .myev-MuiAlert-message': {
      paddingBottom: '0px',
    },
    '& .myev-MuiAlert-icon': {
      color: theme.evPalette.rose[900],
    },
  },

  mainContainer: {
    gap: '8px',
  },

  title: {
    fontFamily: 'Noto Sans',
    fontSize: '14px',
    fontWeight: 600,
    lineHeight: '19.07px',
    textAlign: 'left',
    color: theme.evPalette.charcoal[900],
  },

  errorHeading: {
    fontFamily: 'Noto Sans',
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '18px',
    textAlign: 'left',
    color: theme.evPalette.charcoal[900],
  },

  button: {
    background: 'none',
    color: 'inherit',
    border: 'none',
    padding: '0',
    font: 'inherit',
    cursor: 'pointer',
    outline: 'inherit',
    marginBottom: '4px',
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },

  message: {
    fontFamily: 'Noto Sans',
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '21px',
    textAlign: 'left',
    color: theme.evPalette.huckleberry[800],
    textDecoration: 'underline',
  },
}));
